import { setGoToUrl } from '@chengla_web/cl_newutil'

const currentEnv = process.env.VUE_APP_ENV

export const isLocalEnv = currentEnv === 'dev'
export const isProdEnv = ['prod', 'production', 'alpha'].indexOf(currentEnv) > -1

export function getDomainContext () {
  const { protocol, origin, hostname } = window.location
  const hostParts = hostname.split('.')
  const rootDomain = hostParts.slice(-2).join('.') || hostname

  return {
    protocol,
    origin,
    hostname,
    isLocal: isLocalEnv,
    rootDomain,
    cookieDomain: `.${rootDomain}`,
    isProdEnv
  }
}

export function getCookieOptions () {
  const { cookieDomain, isLocal } = getDomainContext()
  return isLocal ? { path: '/' } : { domain: cookieDomain, path: '/' }
}

export function getAuthCookieNames () {
  const { rootDomain, hostname } = getDomainContext()
  return [
    `h5.${rootDomain}`,
    `m.${rootDomain}`,
    hostname
  ]
}

export function isBizUrl (url, biz, path = '') {
  if (!url) return false
  return url.indexOf(`${setGoToUrl(biz, process.env.VUE_APP_ENV)}${path}`) > -1
}



// WEBPACK FOOTER //
// ./src/common/js/domainRuntime.js